module.exports = __webpack_public_path__ + "static/media/tel2.efe2fffe.jpg";